import React from 'react';
import { IconContainer } from './IconContainer';

const ContractsIcon = (props) => {
    return (
        <IconContainer ariaLabel="contracts" cursor="pointer" { ...props }>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.005 2C20.107 2 21 2.898 21 3.99V20.01C21 21.109 20.107 22 19.005 22H3V2H19.005ZM7 4H5V20H7V4ZM19 4H9V20H19V4ZM24 12V16H22V12H24ZM24 6V10H22V6H24Z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { ContractsIcon };